import type { HubRow } from "./hubTypes";

// Inclusive sheet row numbers.
export type RowRange = [from: number, to: number];

export type RowSelection =
  // `ranges` is null when nothing was typed: every row is selected.
  { ok: true; ranges: RowRange[] | null } | { ok: false; error: string };

const HELP =
  "Escribe números o rangos separados por comas, por ejemplo 12, 15, 40-45.";
const TOKEN = /^(\d+)(?:-(\d+))?$/;

export function parseRowSelection(text: string): RowSelection {
  // A hyphen or an en dash joins a range; spaces around it do not matter.
  const tokens = text
    .replace(/\s*[-–]\s*/g, "-")
    .split(/[\s,;]+/)
    .filter(Boolean);
  if (tokens.length === 0) return { ok: true, ranges: null };

  const ranges: RowRange[] = [];
  for (const token of tokens) {
    const match = TOKEN.exec(token);
    if (!match) {
      return { ok: false, error: `No se entiende «${token}». ${HELP}` };
    }
    const from = Number(match[1]);
    const to = match[2] === undefined ? from : Number(match[2]);
    if (to < from) {
      return {
        ok: false,
        error: `El rango ${token} está al revés: escribe primero la fila menor.`,
      };
    }
    ranges.push([from, to]);
  }
  return { ok: true, ranges };
}

export function selectRows(
  rows: HubRow[],
  ranges: RowRange[] | null,
): HubRow[] {
  if (ranges === null) return rows;
  return rows.filter(({ rowNumber }) =>
    ranges.some(([from, to]) => rowNumber >= from && rowNumber <= to),
  );
}
